import { xingConnect } from '@xingternal/frame-data-provider';

import { SideBar as SideBarComponent } from './SideBar';
import { sideBarSelector } from './selectors';

const SideBar = xingConnect(sideBarSelector)(SideBarComponent);
export { SideBar };
